import { toLocaleShortString } from '@/lib/misc/utils';
interface TruncatedTextProps {
  text: string;
  className?: string;
  count?: number;
  truncate?: boolean;
}
const TruncatedText = ({
  text,
  className = '',
  count = 3,
  truncate = true
}: TruncatedTextProps) => {
  if (!truncate) return <p className={className}>{text}</p>;
  return <p className={className} data-sentry-component="TruncatedText" data-sentry-source-file="TruncatedText.tsx">{toLocaleShortString(text, count)}</p>;
};
export default TruncatedText;